var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Wrapper',[_c('img',{attrs:{"height":_vm.imageHeight,"width":_vm.imageWidth,"src":require(`@/assets/${_vm.image}.svg`),"alt":_vm.message}}),_c('Heading',{attrs:{"color":"gray4","size":3,"title":_vm.message}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }